var render = function render(){var _vm=this,_c=_vm._self._c;return _c('myframe',{attrs:{"without_border":"","without_margin":"","title":"Формула модели"}},[(_vm.base_upks_formula)?_c('div',{staticClass:"d-flex mt-2"},[_vm._v(_vm._s(_vm.base_upks_formula))]):_vm._e(),_c('div',{staticClass:"d-flex mt-2"},[_vm._v(_vm._s(_vm.upks_formula))]),_c('div',{staticClass:"d-flex mt-2"},[_vm._v(_vm._s(_vm.formula))])])
}
var staticRenderFns = []

export { render, staticRenderFns }